import { useQuery } from '@tanstack/react-query'

import { useApi } from '@tabeeb/modules/shared/utils/API'
import { AIQueryKeys } from '../queries'

export default () => {
  const { aiServiceApi: api } = useApi()

  const { isLoading, data } = useQuery({
    queryKey: [AIQueryKeys.NLPModels],
    queryFn: () => api.nlpModels.getAllAsync(),
  })

  return { loading: isLoading, models: data || [] }
}
